var _rect, _rect2, _rect3, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWord(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 32,
    viewBox: "0 0 24 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    rx: 1,
    fill: "#F7F9FA"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 32,
    rx: 1,
    fill: "#EEF0F2"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 23,
    height: 29,
    rx: 0.5,
    fill: "white",
    stroke: "#EDEDED"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.3162 8H13.2671V9.30233C14.9686 9.31209 16.6685 9.28435 18.3684 9.31209C18.731 9.27459 19.0155 9.56279 18.9822 9.93395C19.0092 13.1409 18.9759 16.3495 18.9981 19.5564C18.9822 19.8853 19.0299 20.2499 18.8438 20.5413C18.6117 20.7106 18.3111 20.6895 18.0409 20.7024C16.4489 20.6944 14.8588 20.6977 13.2671 20.6977V22H12.2734C9.85329 21.5474 7.42661 21.1324 5.00171 20.6977C5.00006 16.8998 5.00171 13.1019 5.00171 9.30558C7.4392 8.8693 9.87861 8.44448 12.3164 8H12.3162Z",
    fill: "#2A5699"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.2674 9.79065H18.5148V20.2093H13.2674V18.9069H17.4017V18.2558H13.2674V17.4418H17.4017V16.7906H13.2674V15.9767H17.4017V15.3255H13.2674V14.5116H17.4017V13.8604H13.2674V13.0465H17.4017V12.3953H13.2674V11.5813H17.4017V10.9302H13.2674V9.79065ZM8.28706 12.6671C8.58918 12.6493 8.89131 12.6362 9.19344 12.62C9.40486 13.7189 9.62112 14.8159 9.8501 15.9099C10.0298 14.7801 10.2287 13.6536 10.4209 12.5255C10.7389 12.5142 11.057 12.4962 11.3735 12.4767C11.0141 14.0541 10.6992 15.6446 10.3064 17.2122C10.0408 17.3539 9.64325 17.2057 9.32841 17.2285C9.11685 16.1509 8.87045 15.0797 8.68116 13.9972C8.49517 15.0488 8.25347 16.0906 8.04039 17.1359C7.73509 17.1196 7.42825 17.1001 7.12117 17.0789C6.85733 15.6463 6.54719 14.2235 6.30078 12.7877C6.57263 12.7747 6.84614 12.7632 7.11811 12.7534C7.28183 13.7904 7.46794 14.8226 7.61106 15.861C7.83558 14.7965 8.06444 13.7319 8.28706 12.6671V12.6671Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_119_12563"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white",
    transform: "translate(5 8)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWord);
export default __webpack_public_path__ + "static/media/word.f3534d1718ca4240592b309d87e61018.svg";
export { ForwardRef as ReactComponent };